<template>
<div>
    <div class="common-header-wrap">
        <mt-header title="服务详情" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
        <div class="wrapper">
            <!--默认图片-->
            <div class="goods-image">
                <img :src="goods.o2o_fuwu_goods_image_url">
            </div>
            <div class="goods-price">{{goods.o2o_fuwu_goods_default_price}}元{{goods.o2o_fuwu_goods_spec_quantity>1?'起':''}}</div>
            <div class="body-list">
                <div class="body-item" v-for="(item,index) in bodyList" :key='index'>
                    <div v-if="item.type=='text'">{{item.value}}</div>
                    <div v-if="item.type=='image'"><img v-if="item.value" :src="item.value_url"></div>
                </div>
            </div>
        </div>
         <mt-button class="btn" @click="$router.push({name:'MemberO2oFuwuBuy',query:{o2o_fuwu_goods_id:goods.o2o_fuwu_goods_id}})" size="large" type="primary">立即预约</mt-button>

    </div>
</div>
</template>

<script>
import { Toast } from 'mint-ui'
import { getGoodsInfo } from '../../../api/fuwuGoods'
export default {
  name: 'GoodsDetail',
  data () {
    return {
      goods: {},
      bodyList: [],
      specList: [],
      o2o_fuwu_goods_id: this.$route.query.o2o_fuwu_goods_id ? this.$route.query.o2o_fuwu_goods_id : 0
    }
  },
  methods: {

  },
  created: function () {
    getGoodsInfo(this.o2o_fuwu_goods_id).then(res => {
      this.goods = res.result.o2o_fuwu_goods_info
      if (this.goods.o2o_fuwu_goods_body) {
        this.bodyList = this.goods.o2o_fuwu_goods_body
      }
      this.specList = res.result.o2o_fuwu_goods_spec_list
    }).catch(function (error) {
      Toast(error.message)
    })
  }
}
</script>

<style scoped lang="scss">
    .wrapper{margin-bottom:2rem;padding-top:2rem;}
		.goods-image{background:#fff;text-align:center;}
		.goods-image img{max-width:100%}
    .goods-price{background:#fff;line-height:2rem;color:$primaryColor;text-align: center;font-size:.8rem;}
    .body-list {font-size:.7rem;padding:.5rem;background:#fff;margin-top:1rem;
        img{max-width:100%}
    }
    .btn{position:fixed;bottom:0;width:100%;height:2rem;}
</style>
